export default class CompetitorsFiltersModel {
  constructor(props) {
    this.BoatName = props?.BoatName || "";
    this.HelmName = props?.HelmName || "";
  }
}
